var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn_main flex_start" },
    [
      _vm._l(_vm.btnList, function (btn, index) {
        return [
          !btn.hidden
            ? _c(
                "div",
                {
                  key: index,
                  staticClass: "btn_box",
                  class: [
                    btn.type == "plain" ? "borde_btn" : "",
                    btn.disabled ? "boxDisable" : "",
                    btn.name == "キャンセル" ? "cancelColor" : "",
                  ],
                  style: {
                    "--bg-color": btn.bg ? btn.bg : null,
                    "--hover-color": btn.hover,
                    "--default-color": btn.defaultColor,
                    width: btn.widht == "auto" ? btn.widht : btn.widht + "px",
                    paddingLeft: btn.widht == "auto" ? "7px" : 0,
                    paddingRight: btn.widht == "auto" ? "7px" : 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.open(btn)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex_start icon_box" },
                    [
                      btn.icon
                        ? _c("svg-icon", {
                            staticClass: "iconName",
                            attrs: { "icon-class": btn.icon },
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "btnname" }, [
                        _vm._v(_vm._s(btn.name)),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }